var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',[_c('div',{staticClass:"page-kicker"},[_vm._v(_vm._s(_vm.kicker))]),_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_c('div',{staticClass:"page-actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }